import React from 'react';

import { laneRowFailureLine, NOT_BUILT_HEADING, NOT_BUILT_BODY } from '../../utils/patientCardLanes';
import { HistorySection } from '../visit/history/HistorySection';

const EMPTY_LINE_CLASS = 'text-[0.6875rem] text-slate-500 dark:text-slate-400';

/**
 * A per-sub-section "nothing here" line — never a blank gap (build-plan F7),
 * and never an ABSENCE CLAIM for a lane we could not read (Q2 / QA D3).
 *
 * Shared by every timeline row (`OpdTimelineRow`, `IpdTimelineRow`) so the
 * three-state contract can't fork per row type. The lane is a REQUIRED prop
 * and the state choice lives here, not at the call site: a sub-section
 * physically cannot render its genuine empty line without having handed
 * this component the lane's status first.
 *   - lane not built (`NOT_IMPLEMENTED`) → §12 copy, no retry, no notice;
 *   - lane unreadable (any other `UNAVAILABLE`) → §23.2 softened row line,
 *     with the card-level notice + `Try again` carried once by
 *     `PatientTimeline` rather than shouted on all 40 rows;
 *   - otherwise → the caller's genuine empty text.
 */
export function LaneSubsection({ title, isDark, lane, laneName, emptyText }) {
  if (lane.notBuilt) {
    return (
      <HistorySection title={title} isDark={isDark}>
        <p className={`${EMPTY_LINE_CLASS} font-semibold`}>{NOT_BUILT_HEADING}</p>
        <p className={EMPTY_LINE_CLASS}>{NOT_BUILT_BODY}</p>
      </HistorySection>
    );
  }
  return (
    <HistorySection title={title} isDark={isDark}>
      <p className={EMPTY_LINE_CLASS}>
        {lane.unavailable ? laneRowFailureLine(laneName) : emptyText}
      </p>
    </HistorySection>
  );
}
